import { apiGet, type QueryRecord } from './http-client';

export type PublicTrainerItem = {
  id: number;
  full_name: string | null;
  photo_url: string | null;
  description: string | null;
  description_format: 'html' | 'markdown' | 'plain';
  experience: string | null;
  education: string | null;
  specialization: string | null;
};

/** GET /api/v1/public/trainers — org_slug и key или kid/exp/sig. */
export function fetchPublicTrainers(
  orgSlug: string,
  authQuery: QueryRecord,
  accessToken?: string | null,
  branchId?: number | null
): Promise<PublicTrainerItem[]> {
  const q: QueryRecord = {
    org_slug: orgSlug,
    ...authQuery
  };
  if (branchId != null) {
    q.branch_id = String(branchId);
  }
  return apiGet<PublicTrainerItem[]>('/api/v1/public/trainers', q, { accessToken });
}
